import React from "react"
import texts from "../../../styles/globalText"

export const TextContext = React.createContext(texts)

const TextsProvider = ({children, texts: customTexts}) => {
    return <TextContext.Provider value={customTexts || texts}>{children}</TextContext.Provider>
}

export default TextsProvider
